import { trimAllWhiteCharacters } from 'noddi-util';

export const phoneNumberDto = ({ mobileNumber }: { mobileNumber: string }) => trimAllWhiteCharacters(mobileNumber);
